import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import type { RoleFindInterface } from '@zaoblako/shared/modules/security/dtos/role/role-find.dto';
import type { WorkScheduleFindInterface } from '@zaoblako/shared/modules/security/dtos/work-schedule/work-schedule-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { ApprovalSchemeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/approval-scheme/approval-scheme-find.dto';

import * as yup from 'yup';

/** Common user create/update request body */
export interface UserFormInterface {
  /** Roles to assign */
  roles: OnlyIdRequiredInterface<RoleFindInterface>[];
  /** Related work schedule */
  workSchedule?: OnlyIdRequiredInterface<WorkScheduleFindInterface>;
  /** Counterparty for salary distribution */
  contragent?: OnlyIdRequiredInterface<ContragentFindInterface>;
  /** Approval scheme for BRS tasks */
  approvalScheme?: OnlyIdRequiredInterface<ApprovalSchemeFindInterface>;
  /** User job name */
  job?: string;
}

/** Common user create/update request body - DTO schema */
export const UserFormDto = SerdeDtoClass.create<UserFormInterface>(SecurityDtoKeysEnum.USER_FORM_DTO, {
  roles: {
    label: 'Роли',
    checkers: [SecurityBackendValidatorsEnum.ROLE_ASSERT_EXISTS_BY_DTO],
    serializer: yup
      .array(entityLikeSchema)
      .min(1, DtoMessageEnum.EMPTY_ARRAY),
  },
  workSchedule: {
    optional: true,
    label: 'График работы',
    serializer: entityLikeSchema,
  },
  contragent: {
    optional: true,
    label: 'Контрагент',
    serializer: entityLikeSchema,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
  },
  approvalScheme: {
    optional: true,
    label: 'Схема согласования',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.APPROVAL_SCHEME_ASSERT_EXISTS_BY_DTO],
  },
  job: {
    optional: true,
    label: 'Должность',
    serializer: yup.string(),
  },
});
